import { SessionHeaderItem } from '../../../../exams/components/exam-page/session-header/componenets/session-header-item';
import { Button } from 'primereact/button';
import TaskGrades from '../task-grades';
import { Dialog } from 'primereact/dialog';
import React, { useEffect, useRef, useState } from 'react';
import { taskItemModel } from '../../tasks-section';
import { UploadFile } from '../../../../../../user-page/pages/docs/componenets/upload-file/upload-file';
import { FileUploadFile } from 'primereact/fileupload';
import globalProgramStore from '../../../../../../../stores/program-store';
import globalCourseStore from '../../../../../../../stores/global-course-store';
import { uploadFileOperation } from './operations/upload-file-operation';
import { downloadFileByUrlOperation } from '../../../../../../user-page/pages/docs/componenets/upload-file/operation/download-file-by-url-operation';
import { assignmentFileDelete } from './operations/assignment-file-delete';
import { Calendar } from 'primereact/calendar';
import { updateAssignmentDetailsOperation } from './operations/update-assignment-details-operation';
import { EditText } from '../../../../../../../component/ui/edit-text/edit-text';
import { InputSwitch } from 'primereact/inputswitch';
import { updateGradesPublishedOperation } from './operations/update-grades-published-operation';

/** Calendar / API due dates: avoid UTC midnight shifting the stored calendar day (same pattern as add-new-task). */
function dueDateToLocalCalendarDate(
  value: string | Date | undefined | null,
): Date | undefined {
  if (value == null) return undefined;
  if (typeof value === 'string') {
    const dateOnly = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnly) {
      return new Date(
        Number(dateOnly[1]),
        Number(dateOnly[2]) - 1,
        Number(dateOnly[3]),
      );
    }
  }
  const d = value instanceof Date ? value : new Date(value as string);
  if (isNaN(d.getTime())) return undefined;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

interface TaskPageDialogDatamodel {
  selectedAssignmentId: taskItemModel | undefined;
  onHide: () => any;
}

export const TaskPageDialog: React.FC<TaskPageDialogDatamodel> = ({
  selectedAssignmentId,
  onHide,
}) => {
  const [addFileActive, setAddFileActive] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<FileUploadFile>();
  const [loading, setLoading] = useState(false);

  const hideUploadFileDialog = () => setAddFileActive(false);
  const uploadFile = async () => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;

    await uploadFileOperation(
      currentProgramId,
      currentCourseId,
      selectedAssignmentId?.id,
      uploadedFile,
      setLoading,
      setAddFileActive,
      onHide,
    );
  };

  const downloadAssignmentFile = async (fileUrl: string | undefined | null) => {
    if (fileUrl && fileUrl.length > 0) {
      downloadFileByUrlOperation(fileUrl);
    }
  };

  const [loadingDeleteFile, setLoadingDeleteFile] = useState(false);

  const handleAssignmentFileDelete = async () => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;

    await assignmentFileDelete(
      currentProgramId,
      currentCourseId,
      selectedAssignmentId?.id,
      setLoadingDeleteFile,
    );
  };

  const [updateAssignmentDetailsLoading, setUpdateAssignmentDetailsLoading] =
    useState(false);

  const handleSessionDateChange = async (
    name: string | undefined | null,
    date: Date | null | undefined,
  ) => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;
    await updateAssignmentDetailsOperation(
      currentProgramId,
      currentCourseId,
      selectedAssignmentId?.id,
      name,
      date,
      setUpdateAssignmentDetailsLoading,
    );
  };

  const calendarInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    // When the calendar input gets focused automatically
    if (calendarInputRef.current) {
      // Immediately blur it to remove focus
      calendarInputRef.current.blur();
    }
  }, []);

  const [isEditName, setIsEditName] = useState(false);
  const [assignmentName, setAssignmentName] = useState(
    selectedAssignmentId?.taskName ?? '',
  );

  useEffect(() => {
    setAssignmentName(selectedAssignmentId?.taskName ?? '');
  }, [selectedAssignmentId]);

  const handleGradesPublishedChange = async (value: boolean) => {
    const programId = globalProgramStore.getCurrentId();
    const courseId = globalCourseStore.getCurrentCourse()?.details?.id;

    await updateGradesPublishedOperation(
      programId,
      courseId,
      selectedAssignmentId?.id,
      value,
    );
  };

  return (
    <Dialog
      /*header={'מטלה' + ` - ${selectedAssignmentId?.taskName ?? ''}`}*/
      headerStyle={{ backgroundColor: '#ECFEFF' }}
      header={
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '24px',
          }}
        >
          <SessionHeaderItem
            headline={'מטלה'}
            content={''}
            image={
              <div
                style={{
                  width: '150px',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <i
                  style={{ marginBottom: '12px' }}
                  className="pi pi-calendar mr-2"
                ></i>
                <EditText
                  width={'150px'}
                  height={'25px'}
                  value={assignmentName}
                  onChange={(text: string) => setAssignmentName(text)}
                  onBlur={() => {
                    const trimmed = assignmentName.trim();
                    const previous = (
                      selectedAssignmentId?.taskName ?? ''
                    ).trim();
                    if (trimmed === previous) {
                      return;
                    }
                    handleSessionDateChange(
                      assignmentName,
                      dueDateToLocalCalendarDate(selectedAssignmentId?.dueDate),
                    );
                  }}
                />
              </div>
            }
          />

          <SessionHeaderItem
            headline={'תאריך אחרון להגשה'}
            /*content={`מועד ${numberToHebrewLetter(sessionNumber)}׳`}*/
            image={
              <Calendar
                style={{
                  height: '25px',
                  width: '180px',
                  direction: 'ltr',
                  marginTop: '4px',
                }}
                inputStyle={{ textAlign: 'right' }}
                value={dueDateToLocalCalendarDate(
                  selectedAssignmentId?.dueDate,
                )}
                onChange={(event) => {
                  handleSessionDateChange(
                    selectedAssignmentId?.taskName,
                    event?.value,
                  );
                }}
                showIcon
                autoFocus={false}
                inputRef={calendarInputRef}
                dateFormat={'dd/mm/yy'}
                showOnFocus={false}
              />
            }
          />

          <SessionHeaderItem
            headline={'מסמך דרישות'}
            content={
              selectedAssignmentId?.fileUrl &&
              selectedAssignmentId.fileUrl.length > 0 ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <label>מצורף קובץ 1</label>
                  <Button
                    outlined={true}
                    text
                    style={{ height: '30px' }}
                    severity={'warning'}
                    icon="pi pi-download"
                    tooltip={'לחץ להורדה'}
                    onClick={() =>
                      downloadAssignmentFile(selectedAssignmentId?.fileUrl)
                    }
                  />

                  <Button
                    icon="pi pi-trash"
                    text
                    tooltip={'מחיקת הקובץ'}
                    severity="danger"
                    style={{ height: '30px' }}
                    loading={loadingDeleteFile}
                    onClick={() => handleAssignmentFileDelete()}
                  />
                </div>
              ) : (
                <Button
                  icon="pi pi-plus"
                  tooltip="להוספת מסמך"
                  style={{ height: '30px', width: '30px' }}
                  tooltipOptions={{ position: 'top' }}
                  className="p-button-rounded p-button-primary"
                  onClick={() => setAddFileActive(true)}
                />
              )
            }
            image={<i className="pi pi-file-o mr-2"></i>}
          />

          <SessionHeaderItem
            headline={'פרסום ציונים'}
            content={''}
            image={
              <div style={{ marginTop: '4px' }}>
                <InputSwitch
                  checked={selectedAssignmentId?.isGradesPublished ?? false}
                  onChange={(e) => handleGradesPublishedChange(e.value)}
                />
              </div>
            }
          />
        </div>
      }
      visible={selectedAssignmentId !== undefined}
      style={{
        width: '65vw',
        backgroundColor: 'white',
        borderRadius: '8px',
      }}
      onHide={onHide}
    >
      {selectedAssignmentId && (
        <TaskGrades
          id={selectedAssignmentId.id}
          closeDialog={() => {
            // console.log()
          }}
        />
      )}

      <Dialog
        header="הוספת קובץ"
        visible={addFileActive}
        style={{
          width: '40vw',
          /*minWidth: '40wh',*/
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
        onHide={() => {
          setAddFileActive(false);
        }}
      >
        <UploadFile onFileUploaded={setUploadedFile} />
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
          <Button
            style={{ height: '35px', marginTop: '16px' }}
            label={'העלאת קובץ'}
            onClick={uploadFile}
            loading={loading}
          />
        </div>
      </Dialog>
    </Dialog>
  );
};
